/**
 * A punch list item can be edited or deleted only while it is a draft. Once
 * submitted (submitted, sent_to_contractor, responded, closed or any other
 * status) it changes only through the workflow actions; the api refuses plain
 * edits/deletes with "Only draft punch list items can be edited/deleted".
 */
export function canModifyPunchlistItem(item: { status?: string | null } | null | undefined): boolean {
  return item?.status === 'draft';
}
